import { createAction } from '../../../core/helpers'

import { COMMON_FETCH_ALLERGENS } from '../action-types'

const cleanupCommonFetchAllergens = createAction(COMMON_FETCH_ALLERGENS.CLEANUP)

export default cleanupCommonFetchAllergens
